import type { NavigationScreen } from 'app/types/navigation';
import type { ComponentProps, FC } from 'react';
import { LandingPageContent } from './landing-page-content.large';

type LandingPageScreenComponentProps = ComponentProps<NavigationScreen<'landing-page'>> & { isDesktop: boolean };

export const LandingPageScreenComponent: FC<LandingPageScreenComponentProps> = () => {
  return <LandingPageContent />;
};
